import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import DashboardPersonInfo from "../../assets/images/Frame0001.png";
import '../CoOrperateAdmin/CorporateTableDummy.scss';

const CorporatePersonInfo = () => {
  const location = useLocation();
  const history = useHistory();

  const handleBack = () => {
    history.push("/corporate-admin/table"); // adjust route path as needed
  };

  return (
    <div className="cpi-wrapper-7821">
      {/* Image with back button overlay */}
      <div className="cpi-image-container-7821">
        <img
          src={DashboardPersonInfo}
          alt="Dashboard Person Info"
          className="cpi-dashboard-img-7821"
        />

        {/* Back button positioned over the image where the original button appears */}
        <button
          className="cpi-back-btn-7821"
          onClick={handleBack}
        >
          <svg
            className="cpi-back-icon-7821"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back to previous page
        </button>
      </div>
    </div>
  );
};

export default CorporatePersonInfo;